import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useContext, useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useSendMessage } from 'crustate/react';
import { placeOrder, quote } from '../../../queries/stripe.graphql.js';
import { StripeContext, useInitStripeQuotePaymentMethod, STRIPE_PAYMENT_METHOD_CODE } from '@crossroads/stripe';
import { syncQuote, QUOTE_PLACE_ORDER_RESPONSE } from '@crossroads/shop-state/quote';
import { addMessage } from '@crossroads/shop-state/messages';
import { syncCustomer } from '@crossroads/shop-state/customer';
import { rules, isRequired, Form } from '@awardit/formaggio';
import { useTranslate } from '@awardit/react-use-translate';
import { Foldable } from '@crossroads/ui-components';
import { useFormatAddress } from '../../../helpers/use-format-address.js';
import { StripeCartSummary } from '../../../components/StripeCartSummary/index.js';
import { PaymentMethods } from '../../../components/PaymentMethods/Stripe/index.js';
import { DiscountCode } from '../../../components/DiscountCode/index.js';
import { CustomerServiceLink } from '../CustomerServiceLink/index.js';
import { ProductsList } from '../ProductsList/index.js';
import { ChevronBigSvg, CogSvg } from '../../../icons/index.js';
import cn from 'classnames';
import styles from 'shop-views/StripeView.scss';

function _empty() {}

var validation = rules([isRequired("terms")]);

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

function _callIgnored(body, direct) {
  return _call(body, _empty, direct);
}

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

function _invoke(body, then) {
  var result = body();

  if (result && result.then) {
    return result.then(then);
  }

  return then(result);
}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _rethrow(thrown, value) {
  if (thrown) throw value;
  return value;
}

function _finallyRethrows(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }

  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }

  return finalizer(false, result);
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var Container = _ref => {
  var children = _ref.children,
      right = _ref.right;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.containerBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.containerLeft
  }, children), /*#__PURE__*/React.createElement("div", {
    className: styles.containerRight
  }, right));
};
var StripeView = _ref2 => {
  function _temp5(_wasThrown, _result2) {
    setProcessing(false);
    return _rethrow(_wasThrown, _result2);
  }

  function _temp4() {
    if (payment.code === STRIPE_PAYMENT_METHOD_CODE || payment.code !== "free") {
      return _callIgnored(payWithStripe);
    }
  }

  function _temp3() {
    if (customerQuery !== null && customerQuery !== undefined) {
      return _awaitIgnored(client(customerQuery).then(_temp2));
    }
  }

  function _temp2(_ref4) {
    var customer = _ref4.customer;
    sendMessage(syncCustomer(customer));
  }

  var open = _ref2.open,
      setOpen = _ref2.setOpen,
      enableDiscountCode = _ref2.enableDiscountCode,
      formatPrice = _ref2.formatPrice,
      formatPoints = _ref2.formatPoints,
      client = _ref2.client,
      quote$1 = _ref2.quote,
      quoteData = _ref2.quoteData,
      helpdesk = _ref2.helpdesk,
      checkoutRoute = _ref2.checkoutRoute,
      checkoutContent = _ref2.checkoutContent,
      customerQuery = _ref2.customerQuery,
      setQuoteDiscountCode = _ref2.setQuoteDiscountCode,
      removeQuoteDiscountCode = _ref2.removeQuoteDiscountCode,
      paymentMethodsCards = _ref2.paymentMethodsCards,
      agreement = _ref2.agreement,
      browserProcess = _ref2.browserProcess;
  var t = useTranslate();

  var _useHistory = useHistory(),
      push = _useHistory.push;

  var sendMessage = useSendMessage();
  var formatAddress = useFormatAddress();

  var _useContext = useContext(StripeContext),
      stripe = _useContext.stripe,
      stripePaymentReq = _useContext.stripePaymentReq,
      payWithStripe = _useContext.payWithStripe;

  var _useState = useState({
    terms: false
  }),
      state = _useState[0],
      setState = _useState[1];

  var _useState2 = useState(false),
      processing = _useState2[0],
      setProcessing = _useState2[1];

  var _useState3 = useState(true),
      isBillingValid = _useState3[0],
      setIsBillingValid = _useState3[1];

  var _useState4 = useState("products"),
      openAccordion = _useState4[0],
      setOpenAccordion = _useState4[1];

  var errors = validation(state);
  var formErrors = Array.isArray(quote$1 == null ? void 0 : quote$1.validationErrors) && quote$1.validationErrors.length > 0;
  useInitStripeQuotePaymentMethod(quoteData.data || null);

  var handleResize = () => {
    if (window.innerWidth >= 802) {
      setOpenAccordion("products");
    } else {
      setOpenAccordion("");
    }
  };

  useEffect(() => {
    if (browserProcess) {
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  if (!quoteData.data || quoteData.state !== "LOADED") {
    return null;
  }

  var _quoteData$data = quoteData.data,
      items = _quoteData$data.items,
      payment = _quoteData$data.payment,
      addresses = _quoteData$data.addresses,
      selectedPointPayment = _quoteData$data.selectedPointPayment,
      isVirtual = _quoteData$data.isVirtual;
  var isPointsPayment = selectedPointPayment !== null && selectedPointPayment !== undefined;
  var hasCheckoutContent = checkoutContent !== null && checkoutContent !== undefined;
  var minimumPoints = isPointsPayment && selectedPointPayment.points ? selectedPointPayment.points.min.exVat : "";
  var maximumPoints = isPointsPayment && selectedPointPayment.points ? selectedPointPayment.points.max.exVat : "";
  var billingAddress = addresses.find(x => x.type === "billing");

  var validateBillingInfo = () => {
    var invalidValues = new Set([null, undefined, "", "Förnamn", "Efternamn", "Fornavn", "Etternavn"]);

    if (billingAddress != null && billingAddress.firstname && invalidValues.has(billingAddress.firstname) || billingAddress != null && billingAddress.lastname && invalidValues.has(billingAddress.lastname)) {
      setIsBillingValid(false);
      sendMessage(addMessage("BILLING_ADDRESS_ERROR", "error"));
      return false;
    }

    return true;
  };

  var submit = _async(function (e) {
    e.preventDefault();
    var isValid = validateBillingInfo();

    if (!payment || !isValid) {
      return;
    }

    setProcessing(true);
    return _finallyRethrows(function () {
      return _catch(function () {
        return _invoke(_temp4, function () {
          return _await(client(placeOrder), function (placeOrderData) {
            return _await(client(quote), function (newQuoteData) {
              var _exit = false;

              function _temp(_ref3) {
                var quote = _ref3.quote;

                // Sync quote and return
                if (quote) {
                  sendMessage(syncQuote(quote));
                }

                _exit = true;
              }

              var result = placeOrderData.placeOrder.result;
              return _invoke(function () {
                if (result !== "success") {
                  sendMessage(addMessage(result, "error"));
                  return _await(client(quote), _temp);
                }
              }, function (_result) {
                return _exit ? _result : _invoke(_temp3, function () {
                  if (newQuoteData.quote) {
                    sendMessage(syncQuote(newQuoteData.quote));
                    sendMessage({
                      tag: QUOTE_PLACE_ORDER_RESPONSE,
                      data: newQuoteData.quote
                    });
                  }

                  push(`${checkoutRoute && checkoutRoute.url ? `${checkoutRoute.url}` : "/checkout"}/success`);
                });
              }); // Sync new customer data to get the new point balance etc
            });
          });
        });
      }, function (e_) {
        if (e_.length > 0 && e_[0].message === "errorInsufficientPointsForPurchase") {
          sendMessage(addMessage("errorInsufficientPointsForPurchase", "error"));
        } else {
          var translated = t(e_.message);

          if (translated) {
            sendMessage(addMessage(e_.message, "error"));
          } else {
            sendMessage(addMessage("PLACE_ORDER_CATCH", "error"));
          }
        }
      });
    }, _temp5);
  });

  return /*#__PURE__*/React.createElement(React.Fragment, null, hasCheckoutContent && /*#__PURE__*/React.createElement(Helmet, {
    title: checkoutContent == null ? void 0 : checkoutContent.pageTitleOverview
  }), /*#__PURE__*/React.createElement(Container, {
    right: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StripeCartSummary, {
      open: open,
      setOpen: setOpen,
      allowBackNavigation: false,
      quoteData: quoteData,
      formatPrice: formatPrice,
      formatPoints: formatPoints
    }, /*#__PURE__*/React.createElement(Form, {
      value: state,
      errors: errors,
      onSubmit: submit,
      onChange: x => {
        setState(_extends({}, state, x));
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.paymentMethods
    }, /*#__PURE__*/React.createElement(PaymentMethods, {
      terms: state.terms,
      disabled: formErrors,
      loading: !stripe || !stripePaymentReq,
      processing: processing,
      paymentMethodCode: (payment == null ? void 0 : payment.code) || "",
      paymentMethodsCards: paymentMethodsCards,
      agreement: agreement
    })))), /*#__PURE__*/React.createElement(CustomerServiceLink, {
      helpdesk: helpdesk
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.accordion
  }, /*#__PURE__*/React.createElement("header", {
    className: styles.accordionHeader,
    onClick: () => setOpenAccordion(openAccordion === "products" ? "" : "products")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, t("CHECKOUT.ACCORDION_HEADER_CART"), /*#__PURE__*/React.createElement("span", null, "\xA0(", items ? items.length : "", ")"))), /*#__PURE__*/React.createElement("img", {
    src: ChevronBigSvg,
    className: cn(styles.closeIcon, {
      [styles.open]: openAccordion === "products"
    })
  })), /*#__PURE__*/React.createElement(Foldable, {
    open: openAccordion === "products"
  }, /*#__PURE__*/React.createElement(ProductsList, {
    items: items,
    checkoutRoute: checkoutRoute,
    checkoutContent: checkoutContent,
    formatPrice: formatPrice,
    formatPoints: formatPoints
  }))), /*#__PURE__*/React.createElement("h3", {
    className: styles.heading
  }, hasCheckoutContent ? checkoutContent == null ? void 0 : checkoutContent.paymentDelivery : t("CHECKOUT.PAYMENT_AND_DELIVERY")), /*#__PURE__*/React.createElement("div", {
    className: styles.summary
  }, isPointsPayment && formatPoints && selectedPointPayment.currency.remaining.incVat > 0 && selectedPointPayment.points.selected.exVat > 0 && /*#__PURE__*/React.createElement("div", {
    className: styles.summaryRow
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: styles.title
  }, hasCheckoutContent ? checkoutContent == null ? void 0 : checkoutContent.distribution : "Fördelning"), /*#__PURE__*/React.createElement("p", {
    className: styles.subTitle
  }, formatPoints(selectedPointPayment.points.selected.exVat) + " + " + formatPrice(selectedPointPayment.currency.remaining.incVat))))), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, minimumPoints !== maximumPoints && /*#__PURE__*/React.createElement(Link, {
    className: styles.link,
    to: `${checkoutRoute && checkoutRoute.url ? checkoutRoute.url : "/checkout"}/payment`
  }, hasCheckoutContent ? checkoutContent == null ? void 0 : checkoutContent.edit : t("CHECKOUT.EDIT"), /*#__PURE__*/React.createElement("img", {
    src: CogSvg,
    alt: ""
  })))), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.summaryRow, {
      [styles.hasErrors]: !isBillingValid
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: styles.title
  }, hasCheckoutContent ? checkoutContent == null ? void 0 : checkoutContent.sendTo : t("CHECKOUT.SENT_TO")), isVirtual ? /*#__PURE__*/React.createElement("p", {
    className: styles.subTitle
  }, quote$1 == null ? void 0 : quote$1.email) : /*#__PURE__*/React.createElement("p", {
    className: styles.subTitle
  }, formatAddress(addresses))))), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement(Link, {
    className: styles.link,
    to: `${checkoutRoute && checkoutRoute.url ? checkoutRoute.url : "/checkout"}/shipping`
  }, hasCheckoutContent ? checkoutContent == null ? void 0 : checkoutContent.edit : t("CHECKOUT.EDIT"), /*#__PURE__*/React.createElement("img", {
    src: CogSvg,
    alt: ""
  }))))), enableDiscountCode !== undefined && enableDiscountCode && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: styles.heading
  }, t("CHECKOUT.DISCOUNT_CODE.HEADER")), /*#__PURE__*/React.createElement(DiscountCode, {
    disabled: processing,
    coupon: quote$1 == null ? void 0 : quote$1.coupon,
    setSummaryOpen: setOpen,
    setQuoteDiscountCode: setQuoteDiscountCode,
    removeQuoteDiscountCode: removeQuoteDiscountCode
  }))));
};

export { Container, StripeView };
//# sourceMappingURL=index.js.map
